// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tK","tag":"tL","isRental":"tM","title":"tN","title2":"tO","description":"tP","cta":"tQ","ratingLabel":"tR","ratingLabelSmallScreen":"tS","iconInHotspotVideo":"tT"};